import { render, staticRenderFns } from "./wechat.vue?vue&type=template&id=54d6dee0&scoped=true&"
import script from "./wechat.vue?vue&type=script&lang=js&"
export * from "./wechat.vue?vue&type=script&lang=js&"
import style0 from "./wechat.vue?vue&type=style&index=0&id=54d6dee0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d6dee0",
  null
  
)

export default component.exports